export enum ButtonColor {
  SECONDARY = 'secondary',
  DEFAULT = 'default',
  SUCCESS = 'success',
  DANGER = 'danger',
  TRANSPARENT_DARK = 'transparent-dark',
  TRANSPARENT_LIGHT = 'transparent-light',
  TRANSPARENT_SECONDARY = 'transparent-secondary',
  TRANSPARENT_PINK = 'transparent-pink',
  PRIMARY = 'primary',
  RECRUITER = 'recruiter',
  TRANSPARENT_RECRUITER = 'transparent-recruiter',
  PREFERRED_FREELANCER = 'preferred-freelancer',
  CUSTOM = 'custom',
  TEXT_BLUE = 'text-blue',
  TEXT_PINK = 'text-pink',
  TEXT_RECRUITER = 'text-recruiter',
}

export enum ButtonGroupPosition {
  FIRST = 'first',
  MIDDLE = 'middle',
  LAST = 'last',
}

export type ButtonDisplay = 'inline' | 'block' | 'flex';
